/* tslint:disable */
/* eslint-disable */
/**
 * Nightingale API
 *  ### Welcome to the Nightingale API !   To use the Nightingale API, you will need a `access_token` from **Bridgetech Support**  ## How to use swagger documentation   Click `Authorize` and paste your  `access_token` as `bearerAuth`  ## Design Notes 1. For non-mandatory fields, the API will allow you to submit `null` *or* omit fields entirely. 2. All query parameters are optional. Pagination fields default as follows: * page = 1 * limit = 20
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSubscriptionNotificationRequest
 */
export interface UpdateSubscriptionNotificationRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateSubscriptionNotificationRequest
     */
    endpoint: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSubscriptionNotificationRequest
     */
    public_key: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSubscriptionNotificationRequest
     */
    auth_token: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSubscriptionNotificationRequest
     */
    encoding: string;
}

/**
 * Check if a given object implements the UpdateSubscriptionNotificationRequest interface.
 */
export function instanceOfUpdateSubscriptionNotificationRequest(value: object): value is UpdateSubscriptionNotificationRequest {
    if (!('endpoint' in value) || value['endpoint'] === undefined) return false;
    if (!('public_key' in value) || value['public_key'] === undefined) return false;
    if (!('auth_token' in value) || value['auth_token'] === undefined) return false;
    if (!('encoding' in value) || value['encoding'] === undefined) return false;
    return true;
}

export function UpdateSubscriptionNotificationRequestFromJSON(json: any): UpdateSubscriptionNotificationRequest {
    return UpdateSubscriptionNotificationRequestFromJSONTyped(json, false);
}

export function UpdateSubscriptionNotificationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSubscriptionNotificationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'endpoint': json['endpoint'],
        'public_key': json['public_key'],
        'auth_token': json['auth_token'],
        'encoding': json['encoding'],
    };
}

export function UpdateSubscriptionNotificationRequestToJSON(json: any): UpdateSubscriptionNotificationRequest {
    return UpdateSubscriptionNotificationRequestToJSONTyped(json, false);
}

export function UpdateSubscriptionNotificationRequestToJSONTyped(value?: UpdateSubscriptionNotificationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'endpoint': value['endpoint'],
        'public_key': value['public_key'],
        'auth_token': value['auth_token'],
        'encoding': value['encoding'],
    };
}

